<template>
  <Teleport to="body">
  <div class="modal fade" tabindex="-1" :id="idModal">
    <div class="modal-dialog modal-dialog-centered">
      <form method="post" @submit.prevent="submit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <p class="save-model-hint">{{ hint }}</p>
            <label :for="idModal + '_name'" class="required form-label">Nome do modelo</label>
            <input type="text" class="form-control form-control-solid" :id="idModal + '_name'"
                   v-model="name" maxlength="100" required autocomplete="off"
                   placeholder="Ex. Amigdalite aguda — adulto">
            <p v-if="summary" class="save-model-summary">{{ summary }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary" :disabled="saving || name.trim().length < 3">
              {{ saving ? 'Salvando...' : 'Salvar modelo' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </Teleport>
</template>

<script>
export default {
  name: "SaveAsModelModal",
  emits: ['save'],
  props: {
    idModal: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Salvar como modelo',
    },
    hint: String,
    summary: String,
    /** Nome sugerido. O médico reencontra o modelo por ele numa lista depois. */
    suggestion: {
      type: String,
      default: '',
    },
    saving: Boolean,
  },
  data() {
    return {
      name: '',
    }
  },
  watch: {
    suggestion: {
      immediate: true,
      handler(value) {
        this.name = value ?? '';
      },
    },
  },
  methods: {
    submit() {
      const name = this.name.trim();
      if (name.length < 3) {
        return;
      }

      this.$emit('save', name);
    },
  },
}
</script>

<style scoped>
.save-model-hint {
  color: #7e8299;
  margin-bottom: 16px;
}

.save-model-summary {
  color: #7e8299;
  font-size: 0.85rem;
  margin: 8px 0 0;
}
</style>
